"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizedDeepEqual = exports.deepEqual = void 0;
const clone_1 = require("./clone");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const equal = require('deep-eql');
/**
 * Wraps deep-eql to ensure that all code uses the same solid deep-equal method
 * and that we can replace it later easily.
 *
 * Uses recursion and sorting.
 */
const deepEqual = (a, b) => equal(a, b);
exports.deepEqual = deepEqual;
const sanitizedDeepEqual = (a, b, options = { removeNully: true }) => equal((0, clone_1.clonePrimitive)(a, options), (0, clone_1.clonePrimitive)(b, options));
exports.sanitizedDeepEqual = sanitizedDeepEqual;
//# sourceMappingURL=deepEqual.js.map